<template>
  <b-container class="mt-5">
    <b-row>
      <b-col>
        <div class="error">
          <h2>{{ $te(`error.titles.${type}`) ? $t(`error.titles.${type}`, attributes) : $t('error.titles.default', attributes) }}</h2>
          <div class="error-details">{{ $te(`error.messages.${type}`) ? $t(`error.messages.${type}`, attributes) : $t('error.messages.default', attributes) }}</div>
          <b-button variant="primary" class="mt-3" size="sm" :href="`${cockpit}`">{{$t('error.back')}}</b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  props: {
    type: null,
    attributes: null
  },
  data() {
    return {
      cockpit: process.env.VUE_APP_COCKPIT_URL
    };
  },
};
</script>
<style lang="scss" scoped>
.error {
  text-align: center;
}
.error-details {

}
</style>